import { InfoField } from '@occc-app/design-system';
import { routeCreator as productGroupRouteCreator } from '@occc-app/routes/ProductGroup/utils';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { purchaseThresholdLabelByCount } from '../constants';
import { ChipList } from '../../../components';
import { ConstraintSupplementalData } from '../../../component-details.types';
import { formatPurchaseThresholdValue, formatValues } from '../../formatters';
import { isProductGroup } from '../../utils';

export const PurchaseThresholdConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const cst = getConstraintsByType('ConstraintPurchaseThreshold', constraints);
  const purchaseThresholdValue = formatValues(
    cst.map(
      (c) =>
        `At least ${
          purchaseThresholdLabelByCount[c.countProductsBy]
        } of ${formatPurchaseThresholdValue(c.countProductsBy, c.threshold)}`,
    ),
    ';',
  );

  return <InfoField label='Purchase Threshold' value={purchaseThresholdValue} />;
};

export const PurchaseEligibleProductGroupConstraint = ({
  constraints,
  constraintSupplementalData,
}: {
  constraints: ConstraintFragment[];
  constraintSupplementalData?: ConstraintSupplementalData;
}) => {
  const cst = getConstraintsByType('ConstraintPurchaseThreshold', constraints);
  const productGroupsMap = constraintSupplementalData?.ConstraintPurchaseThreshold;
  const eligibleProductGroupIds = [...new Set(cst.flatMap((c) => c.eligibleProductGroupIds ?? []))];
  const eligibleProductGroups = eligibleProductGroupIds
    .map((id) => productGroupsMap?.[id])
    .filter(isProductGroup);

  if (eligibleProductGroups.length) {
    const linkItems = eligibleProductGroups.map((g) => ({
      label: g.name,
      href: productGroupRouteCreator.details(g.id),
    }));
    return <ChipList label='Eligible Product Groups' items={linkItems} />;
  }

  return (
    <InfoField label='Eligible Product Groups' value={formatValues(eligibleProductGroupIds)} />
  );
};
